const saferGuides = {
  foundational: [
    121, 122,
  ],
  infrastructure: [
    119, 125, 124
  ],
  clinicalProcess: [
    123, 120, 126, 118
  ],
}

const annualMeeting = {
  fifteenDay1: [
    2184, 2185, 2186, 2187, 2188, 2189, 2190, 2191
  ],
  fifteenDay2: [
    2192, 2193, 2194, 2195, 2197
  ],
  elevenDay1: [
    1542, 1522, 1543, 1523, 1524, 1525, 1526, 1527, 1528, 1529
  ],
  elevenDay2: [
    1530, 1531, 1532, 1533, 1534, 1535, 1536
  ],
}

const quarterlyCall = [
  2883, 2823,  2783,  2643,  2472,  2431,  2373,  2329,  2288,  2264,  2204,  2164,  2084,  1982,
  1922, 1902,  1903,  1822,  1782,  1622,  1428,  1348,  1208,  1167,  1147,  1107,
  784,  704,  189,  190, 191,  192
]

const opioidCrisis = [
  1466,  1467,  1468,  1469,  1470,  1471,  1472,  1473,  1474,  1475,  1476,  1477,  1478,
  1479
]

export default {saferGuides, annualMeeting, quarterlyCall, opioidCrisis};